import { RouteStore } from 'fluxible-router';

export default RouteStore.withStaticRoutes({
  index: {
    path: '/',
  },
});



// WEBPACK FOOTER //
// ./src/app/stores/Route/Route.js